import React, { useEffect, useState } from 'react'
import Footer from '../../components/Footer'
import FooterArchievement from '../../components/Footer/FooterArchievement'
import GoogleAdsense from '../../components/Ads/GoogleAdsense'
import getDeviceConfig from '../../hooks/Breakpoint'
import styles from './contact.module.sass'
import { Col, Form, Input, message, Row } from 'antd'

import { useTranslation } from 'next-i18next'
import getLanguage from '../../utils/i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { requestContactUs } from '../../redux/actions/contact'
import { fetchStatistics } from '../../redux/actions/file_list.js'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { NextSeo } from 'next-seo'
import HeaderBar from '../../components/HeaderBar'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import FeatureListContainer from '../../components/FeatureItem/FeatureListContainer'

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 }
};

const ContactForm = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { error, data, requesting } = useSelector(
    state => state.contact,
    shallowEqual
  );
  const dispatch = useDispatch();
  const onFinish = async values => {
    if (!executeRecaptcha) {
      return;
    }
    // eslint-disable-next-line
    const captcha_token = await executeRecaptcha("contact_form");
    dispatch(requestContactUs({ ...values, captcha_token }));
  };

  useEffect(() => {
    if (Object.keys(data).length) {
      message.success("Send message successfully");
    }

    if (error) {
      message.error(error.message, 5);
    }
  }, [error, data]);
  return (
    <Form name="basic" onFinish={onFinish}>
      <Form.Item {...formItemLayout} name="name">
        <Input placeholder="Your full name" className='custom-input-in-contact-form' />
      </Form.Item>
      <Form.Item
        {...formItemLayout}
        name="email"
        rules={[{ type: "email", required: true, message: 'Please input your email!' }]}
      >
        <Input placeholder="Your email address" className='custom-input-in-contact-form' />
      </Form.Item>
      <Form.Item
        {...formItemLayout}
        name="message"
        rules={[{ required: true, message: 'Please input your message!' }]}
      >
        <Input.TextArea
          placeholder="Your message here"
          autoSize={{ minRows: 4 }}
          className='custom-input-in-contact-form'
        />
      </Form.Item>
      <Form.Item>
        <div className={styles.btnSendMessage}>
          <button
            type="submit"
            className={styles.btn_submit}
          >
            Send message
          </button>
        </div>
      </Form.Item>
    </Form>
  );
};
const Contact = () => {
  const [adsOffset, setAdsOffset] = useState(1000)
  const { t } = useTranslation();
  const { isXl, isXxl } = getDeviceConfig()
  const dispatch = useDispatch()

  const { statistic } = useSelector(state => state.fileList)

  useEffect(() => {
    try {
      dispatch(fetchStatistics())
    } catch (error) {
      console.log(error);
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleScroll = () => {
    const adsContainer = document.querySelector('div.ads_container')
    if (adsContainer) {
      const distanceScroll = document.body.scrollTop
      const elRect = adsContainer.getBoundingClientRect()
      const elOffset = elRect.top
      setAdsOffset(distanceScroll + elOffset)
    }
  }

  return (
    <div>
      <NextSeo
        title='Contact'
        nofollow={true}
        canonical='https://evano.com/contact'
        openGraph={{
          title: 'Contact',
          url: 'https://evano.com/contact'
        }}
      />
      <HeaderBar />
      <section className={styles.pre_header}>
        <div className="container">
          <Row>
            <Col xs={24} md={20} className="text-center mx-auto">
              <h1 className={`${styles.mt}`}>{t("about:contact_title")}</h1>
              <h2 className={styles.small_title_contact}>
                {t("about:small_title_contact")}
              </h2>
            </Col>
          </Row>
        </div>
      </section>
      <section className={styles.section_contact_form}>
        <div className='ads_container mx-auto' style={{position: 'relative'}}>
          <div key='v__adsbygoogle_left' className={`v__adsbygoogle left contact ${adsOffset < 100 ? 'fixed' : ''}`}>
            { isXl || isXxl ? (<GoogleAdsense
              className="adsbygoogle"
              style={{display: 'inline-block', 'min-width': '200px', 'min-height': '50px'}}
              client='ca-pub-6022273213615485'
              slot='6680291945'
              format='auto'
              responsive={true} />) : null }
          </div>
          <div className="container">
            <Row>
              <Col xs={24} lg={20} className="mx-auto">
                <Row>
                  <div className={styles.drop_container_wrapper}>
                    <div className={styles.drop_container_top}>
                      <span className={styles.red} />
                      <span className={`${styles.red} ${styles.yellow}`} />
                      <span className={`${styles.red} ${styles.green}`} />
                    </div>
                    <div className={styles.contact_form}>
                      <div className={styles.left_form}>
                        <h3 className={styles.left_header}>
                          {t("about:left_header_contact_form")}
                        </h3>
                        <p className={styles.left_text}>
                          {t("about:left_contact_form_text")}
                        </p>
                      </div>
                      <div className={styles.right_form}>
                        <ContactForm />
                      </div>
                    </div>
                  </div>
                </Row>
              </Col>
            </Row>
          </div>
          <div key='v__adsbygoogle_right' className={`v__adsbygoogle right contact ${adsOffset < 100 ? 'fixed' : ''}`}>
            { isXl || isXxl ? (<GoogleAdsense
              className="adsbygoogle"
              style={{display: 'inline-block', 'min-width': '200px', 'min-height': '50px'}}
              client='ca-pub-6022273213615485'
              slot='6680291945'
              format='auto'
              responsive={true} />) : null }
          </div>
        </div>
      </section>
      <section className={styles.section_contact_us}>
        <div className="container">
          <Row>
            <Col xs={24} lg={20} className="mx-auto">
              <Row>
                <div className={styles.contact_us}>
                  <div className={styles.phone}>
                    <div className={styles.ask_question_if_needed}>
                      {t("about:ask_question_if_needed")}
                    </div>
                    <div className={styles.specific_contacts}>
                      <div>
                        <div className={styles.icon}>
                          <img
                            src={require("public/images/phone_contact.svg")}
                            alt="phone contact"
                          />
                        </div>
                        <div className={styles.text}>
                          Give us a call at{" "}
                          <a href="tel:+84-963-820-222">+84-963-820-222</a>
                        </div>
                      </div>
                      <div>
                        <div className={styles.icon}>
                          <img
                            src={require("public/images/dropbox_contact.svg")}
                            alt="email contact"
                          />
                        </div>
                        <div className={styles.text}>
                          Drop us a line via email:{" "}
                          <a href="mailto:contact@evano.com">
                            contact@evano.com.
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.office_wrapper}>
                    <div className={styles.office}>
                      <div className={styles.office_header}>Office :</div>
                      <p className={styles.office_text}>
                        {t("about:office_address")}
                      </p>
                    </div>
                  </div>
                </div>
              </Row>
            </Col>
          </Row>
        </div>
      </section>

      <section className={styles.feature}>
        <FeatureListContainer t={t}/>
      </section>

      <section className="pre_footer">
      { statistic ? <FooterArchievement totalFile={statistic.total_file} totalFileSize={statistic.total_file_size}/> : null }
      </section>
      <Footer />
    </div>
  );
};

export const getStaticProps = async ctx => ({
  props: {
    ...(await serverSideTranslations(getLanguage(ctx), ['common', 'header', 'footer', 'about'])),
  }
});

export default Contact
